import axios from 'axios'

// utils and config
import baseUrl from '../config'
import getToken from 'utils/getToken'
import cleanPayload from 'utils/cleanPayload'

export const fetchOrganisations = async (payload = {}) => {
  const cleanedPayload = cleanPayload(payload)
  const token = getToken()
  const response = await axios.get(`${baseUrl}/organisations`, {
    params: { token, ...cleanedPayload }
  })

  return response.data
}

export const fetchOwnOrganisations = async (payload = {}) => {
  const cleanedPayload = cleanPayload(payload)
  const token = getToken()
  const response = await axios.get(`${baseUrl}/own-organisations`, {
    params: { token, ...cleanedPayload }
  })

  return response.data
}

export const fetchOrganisation = async id => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/organisations/${id}`, {
    params: { token }
  })

  return response.data
}

export const fetchLearners = async id => {
  const token = getToken()
  const response = await axios.get(`${baseUrl}/organisations/${id}/learners`, {
    params: { token }
  })

  return response.data
}

export const fetchOrgForPublicPage = async orgName => {
  const token = getToken()

  const hasAlphabetCharacters = orgName.match(/\D/)
  if (hasAlphabetCharacters) {
    const response = await axios.get(`${baseUrl}/orgs/${orgName}`, {
      params: { token }
    })
    return response.data
  }

  const orgObject = await axios.get(`${baseUrl}/orgs/id/${orgName}`)
  const urlName = orgObject.data.url_name

  const response = await axios.get(`${baseUrl}/orgs/${urlName}`, {
    params: { token }
  })
  return response.data
}

export const createOrganisation = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios({
    method: 'post',
    url: `${baseUrl}/organisations`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })

  return response.data
}

export const claimOrganisation = async data => {
  const token = getToken()
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/organisations/claim`,
    data: { ...data, token }
  })

  return response.data
}

export const claimOrganisationRequest = async data => {
  const token = getToken()
  const response = await axios({
    method: 'post',
    url: `${baseUrl}/organisations/claim-request`,
    data: { ...data, token }
  })

  return response.data
}

export const updateOrganisation = async data => {
  const token = getToken()
  if (token) data.append('token', token)

  const response = await axios({
    method: 'put',
    url: `${baseUrl}/organisations/${data.get('id')}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } }
  })
  return response.data
}

export const updateBillingInfo = data => {
  const token = getToken()
  return axios.put(`${baseUrl}/organisations/update-billing-info/${data.id}`, { ...data, token })
}

export const deleteOrganisation = async organisationId => {
  const token = getToken()
  const response = await axios.delete(`${baseUrl}/organisations/${organisationId}`, {
    data: { token, organisationId }
  })
  return response
}

export const removeOrgAdmin = async ({ organisationId, adminId }) => {
  const token = getToken()
  return await axios.delete(`${baseUrl}/organisations/${organisationId}/remove-admin/${adminId}`, {
    data: { token }
  })
}

export const addOrgAdmin = async data => {
  const token = getToken()
  const { organisationId } = data
  return await axios.post(`${baseUrl}/organisations/${organisationId}/add-admin`, {
    ...data,
    token
  })
}

export const updateOrgAdmin = async data => {
  const token = getToken()
  const { adminId, organisationId } = data
  return await axios.put(`${baseUrl}/organisations/${organisationId}/update-admin/${adminId}`, {
    ...data,
    token
  })
}
